import React                                from "react";
import { Editor }                           from "@tinymce/tinymce-react";
import { isDarkMode, GetAppLang }           from "Utilities/utils";

export const DisplayContent        = React.memo(({...props})    => {
    const {Content, ContentStyle, ContentClass} = props;
    return(
        <div dangerouslySetInnerHTML={{ __html: Content }} style={ContentStyle} className={ContentClass}/>
    );
});
export const ContentEditor         = React.memo(({...props})    => {
    const { value, onChange , allowHtml = true} = props;
    
    let language = undefined;

    const ApplicationLanguage = GetAppLang();

    if (ApplicationLanguage === "Pt")
        language = 'pt_BR';

    if (ApplicationLanguage === "Es")
        language = 'es';

    return (
        <Editor
            tinymceScriptSrc="/lib/tinymce-local/tinymce.min.js"
            value={value}
            onEditorChange={onChange}
            init={{
                height: 400,
                menubar: true,
                base_url: '/lib/tinymce-local',
                suffix: '.min',
                license_key: 'gpl',
                language: language, 
                plugins: allowHtml ? 'link image code lists table' : 'link image lists table',
                toolbar: allowHtml ? 'undo redo | bold italic | alignleft aligncenter alignright | code' : 'undo redo | bold italic | alignleft aligncenter alignright',
                branding: false,
                promotion: false,
                skin: isDarkMode() ? 'oxide-dark' : 'oxide',
                content_css: isDarkMode() ? 'dark' : 'default',
            }}
        />
    );
});